import { isOfType } from '~publish/helpers/typeGuards'

import type { PostMediaAsset_AssetData } from './PostMediaAsset'

export const getAltText = (asset: PostMediaAsset_AssetData): string => {
  if (isOfType(asset, 'ImageAsset')) {
    return asset.image.altText || 'Image preview'
  }

  if (isOfType(asset, 'VideoAsset')) {
    return 'Video preview'
  }

  if (isOfType(asset, 'DocumentAsset')) {
    return 'Document preview'
  }

  return 'Media preview'
}
